import {
    BRANCHNAMELISTPARTNER_SUCCESS,
    BRANCHNAMELISTPARTNER_FAILED,
    RESET_BRANCHNAMELISTPARTNER,
    LOADING_BRANCHNAMELISTPARTNER,
    NETWORK_ERROR_BRANCHNAMELISTPARTNER
} from "../types/index";


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BRANCHNAMELISTPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BRANCHNAMELISTPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BRANCHNAMELISTPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_BRANCHNAMELISTPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BRANCHNAMELISTPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};